module.exports = __webpack_public_path__ + "img/1.57b4f2df.png";